// extracted by mini-css-extract-plugin
export default {"cls1":"News-cls1_yUJ","cls2":"News-cls2_qxi News-cls1_yUJ","variant-dense":"News-variant-dense_UEa"};